export const PRODUCT_IMAGE = "https://static.prod-images.emergentagent.com/jobs/de4877d6-2cf2-488d-b80d-0ed4b81de5ea/images/27fb368343005aeffcc95287c3332efc0fa0d1312aaa66b1b5082115375ab3e4.jpeg";
export const LIFESTYLE_IMAGE = "https://images.unsplash.com/photo-1713201507895-1f90510984e8?crop=entropy&cs=srgb&fm=jpg&q=85";
export const STATUS_LABELS = { awaiting_payment: "En attente de paiement", confirmed: "Confirmée", paid: "Payée", shipped: "Expédiée", delivered: "Livrée", cancelled: "Annulée" };
export const FALLBACK = {
  name: "Plateforme vibrante fitness avec élastiques – VibeFit",
  description: "Plateforme vibrante professionnelle pour tonifier votre corps, améliorer votre circulation et vous entraîner facilement à domicile.",
  rating: 4.7,
  review_count: 184,
  variants: [
    { id: "home-pro", name: "Blanc champagne", subtitle: "Avec élastiques de résistance", price: 149 },
    { id: "elite-trainer", name: "Noir premium", subtitle: "Avec élastiques + tapis", price: 189 },
    { id: "carbon-edition", name: "Rose poudré", subtitle: "Avec accessoires complets", price: 219 },
  ],
};
